import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { MarketProDesignModule } from '../../../../../marketpro-design-lib/src';
import { SystemGroupsService } from '../main/services/system-groups.service';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { LoginComponent } from './components/login/login.component';
import { PasswordComponent } from './components/password/password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { HasAccessDirective } from './directives/has-access.directive';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { AuthService } from './services/auth.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { HeaderComponent } from './components/header/header.component';
import { NewUserComponent } from './components/new-user/new-user.component';
import { SharedAnimationModule } from '../shared-animation.module';
import { PasswordStrengthComponent } from './components/password-strength/password-strength.component';

@NgModule({
  imports: [
    MarketProDesignModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    FontAwesomeModule,
    SharedAnimationModule,
  ],
  declarations: [
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    PasswordComponent,
    HeaderComponent,
    HasAccessDirective,
    NewUserComponent,
    PasswordStrengthComponent,
  ],
  exports: [
    LoginComponent,
    ForgotPasswordComponent,
    HeaderComponent,
    ResetPasswordComponent,
    PasswordComponent,
    HasAccessDirective,
    NewUserComponent,
    PasswordStrengthComponent,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      deps: [AuthService, SystemGroupsService],
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
})
export class AuthModule {}

function appInitializerFn(
  authService: AuthService,
  systemGroupsService: SystemGroupsService
): () => Observable<any> {
  return () =>
    authService
      .getCurrentUserInfo()
      .pipe(concatMap(() => systemGroupsService.getSystemGroupsRequest()));
}
